module.exports = __webpack_public_path__ + "static/media/empreinte01.dee25cf1.jpg";